import React, { useState, useEffect } from 'react';
import { FiX } from 'react-icons/fi';

export default function CookieBanner() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already acknowledged the cookie notice
    const cookieAcknowledged = localStorage.getItem('cookie-acknowledged');
    if (!cookieAcknowledged) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie-acknowledged', 'true');
    localStorage.setItem('cookie-acknowledged-date', new Date().toISOString());
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-lg z-50">
      <div className="max-w-7xl mx-auto px-4 py-4">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="flex-1">
            <div className="flex items-start gap-3">
              <div className="flex-1">
                <h3 className="font-semibold text-gray-900 text-sm mb-1">
                  Cookies Required
                </h3>
                <p className="text-sm text-gray-700 leading-relaxed">
                 To give you the best experience, Topdial.ng uses essential cookies that are necessary for core site features to be  seamless and work as intended..{' '}
                  <a 
                    href="/privacy-policy" 
                    className="text-wine underline hover:text-wine-dark transition-colors"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Learn more in our Privacy Policy
                  </a>
                </p>
              </div>
            </div>
          </div>
          
          <div className="flex items-center gap-2 min-w-fit">
            <button
              onClick={handleAccept}
              className="bg-wine hover:bg-wine-dark text-white px-6 py-2 rounded-md text-sm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-wine focus:ring-offset-2"
            >
              Okay
            </button>
            <button
              onClick={handleAccept}
              className="p-2 text-gray-400 hover:text-gray-600 transition-colors focus:outline-none focus:ring-2 focus:ring-wine focus:ring-offset-2 rounded-md"
              aria-label="Dismiss cookie notice"
            >
              <FiX className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
